import styled from 'styled-components'
import { Flex, Box } from 'rebass'

export const KeywordSearch = styled(Flex)``
export const KeywordSearchLabel = styled(Box)`
  color: ${(props) => props.theme.colors.blue};
  line-height: 46px;
  text-transform: none;
  font-size: medium;
`

export const KeywordSearchInput = styled(Box)``
